import en from './locales/en';
import ru from './locales/ru';

export const LOCALES = { en: 'en', ru: 'ru' };
export const DEFAULT_LOCALE = LOCALES.en;

const catalogs = { en, ru };

let currentLocale = DEFAULT_LOCALE;
const listeners = new Set();

const normalizeLocale = (value) => (value === LOCALES.ru ? LOCALES.ru : LOCALES.en);

const resolvePath = (obj, path) => {
  if (!obj || !path) return undefined;
  return String(path).split('.').reduce((acc, key) => (
    acc && typeof acc === 'object' ? acc[key] : undefined
  ), obj);
};

const interpolate = (template, vars) => {
  if (!vars || typeof template !== 'string') return template;
  return template.replace(/\{(\w+)\}/g, (_, key) => (
    vars[key] == null ? `{${key}}` : String(vars[key])
  ));
};

export const getLocale = () => currentLocale;

export const setLocale = (next) => {
  const locale = normalizeLocale(next);
  if (locale === currentLocale) return locale;
  currentLocale = locale;
  listeners.forEach((listener) => {
    try {
      listener(locale);
    } catch {
      // ignore subscriber errors
    }
  });
  return locale;
};

export const subscribeLocale = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/** Translate a dotted key. Falls back to English, then the key itself. */
export const t = (key, vars) => {
  const primary = resolvePath(catalogs[currentLocale], key);
  const fallback = currentLocale === LOCALES.en
    ? undefined
    : resolvePath(catalogs.en, key);
  const template = primary ?? fallback ?? key;
  return interpolate(template, vars);
};

export const applyHtmlLang = (locale = currentLocale) => {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('lang', normalizeLocale(locale));
};
